import { render } from "./BackgroundImageEditor.vue?vue&type=template&id=1c2b5b64"
import script from "./BackgroundImageEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundImageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__